import React, { useCallback } from 'react';
import AddItem from '@wix/da-shared-react/pkg/AddItem';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { MAX_TIERS_COUNT } from '../constants';

export type Props = {
  className?: string;
  count: number;
};
export const AddTierCard: React.FC<Props> = ({ className, count }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const createTier = useCallback(
    () =>
      dispatch(
        pushModal(ModalType.TIER_EDIT, {
          wrapInModal: false,
        })
      ),
    [dispatch]
  );

  const canCreateTier = count < MAX_TIERS_COUNT;

  return canCreateTier ? (
    <AddItem
      className={className}
      title={t('widgets.tiers.addItem.title')}
      subtitle={t('widgets.tiers.addItem.subtitle', {
        count,
        total: MAX_TIERS_COUNT,
      })}
      onClick={createTier}
    />
  ) : (
    <AddItem
      className={className}
      title={t('widgets.tiers.addItem.title.disabled')}
      subtitle={t('widgets.tiers.addItem.subtitle.disabled')}
      disabled={true}
    />
  );
};

AddTierCard.displayName = 'AddTierCard';
export default AddTierCard;
